import { CommentsType } from "./types";

export const commentsContents: CommentsType[] = [
  {
    id: 0,
    image: "https://swiperjs.com/demos/images/nature-1.jpg",
    comment:
      "قیمت‌ها واقعاً مناسب بودن، چون خودشون واردکننده‌ان. تیم مشاوره‌شون هم دقیق و باحوصله راهنمایی‌م کرد.",
    name: "علیرضا احمدی",
    city: "تهران",
  },
  {
    id: 1,
    image: "https://swiperjs.com/demos/images/nature-2.jpg",
    comment:
      "قیمت‌ها واقعاً مناسب بودن، چون خودشون واردکننده‌ان. تیم مشاوره‌شون هم دقیق و باحوصله راهنمایی‌م کرد.",
    name: "علیرضا احمدی",
    city: "تهران",
  },
  {
    id: 2,
    image: "https://swiperjs.com/demos/images/nature-3.jpg",
    comment:
      "قیمت‌ها واقعاً مناسب بودن، چون خودشون واردکننده‌ان. تیم مشاوره‌شون هم دقیق و باحوصله راهنمایی‌م کرد.",
    name: "علیرضا احمدی",
    city: "تهران",
  },
  {
    id: 3,
    image: "https://swiperjs.com/demos/images/nature-4.jpg",
    comment:
      "قیمت‌ها واقعاً مناسب بودن، چون خودشون واردکننده‌ان. تیم مشاوره‌شون هم دقیق و باحوصله راهنمایی‌م کرد.",
    name: "علیرضا احمدی",
    city: "تهران",
  },
];
